<template>
  <div class="customer-pesonal-workImpactFactors">
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 出车状态 -->
        <PieChartCard
          :title="workStatusData.title"
          :dataDesc="workStatusData.dataDesc"
          :dataUpdateTime="workStatusData.dataUpdateTime"
          :dataType="workStatusData.dataType"
          :total="workStatusData.total"
          :totalTitle="workStatusData.totalTitle"
          :unit="workStatusData.unit"
          :ratioList="workStatusData.ratioList"
          :seriesData="workStatusData.seriesData"
        />
      </el-col>
      <el-col :span="12">
        <!-- 不可出车原因 -->
        <PieChartCard
          :title="noWorkReasonData.title"
          :dataDesc="noWorkReasonData.dataDesc"
          :dataUpdateTime="noWorkReasonData.dataUpdateTime"
          :dataType="noWorkReasonData.dataType"
          :total="noWorkReasonData.total"
          :totalTitle="noWorkReasonData.totalTitle"
          :unit="noWorkReasonData.unit"
          :ratioList="noWorkReasonData.ratioList"
          :seriesData="noWorkReasonData.seriesData"
        />
        </el-col>
      </el-row>

      <!-- 单车出车率分布 -->
      <GradeBar
        :title="workRateInfoData.title"
        :dataDesc="workRateInfoData.dataDesc"
        :dataUpdateTime="workRateInfoData.dataUpdateTime"
        :legendsData="workRateInfoData.legendsData"
        :data="workRateInfoData.data"
        :tooltip="workRateInfoData.tooltip"
      />
  </div>
</template>
<script>
import PieChartCard from '@/bizComponents/Dashboard/cards/pieChartCard/index.vue'
import GradeBar from '@/bizComponents/Dashboard/gradeBar/index.vue'
// eslint-disable-next-line import/no-cycle
import { getPersonWorkImpactFactors } from '@/api/domain/customers'
import { WORK_RATE_LIST } from '../../../customerOperate/list/config'

export default {
  components: {
    PieChartCard,
    GradeBar,
  },
  data() {
    const { spId = '' } = this.$route.query

    return {
      spId,
      // 出车状态
      workStatusData: {
        title: '出车状态',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        totalTitle: '昨日出车数量',
        total: '',
        unit: '',
        ratioList: [],
        seriesData: [],
      },
      // 不可出车原因
      noWorkReasonData: {
        title: '不可出车原因',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        totalTitle: '昨日未出车数量',
        total: '',
        unit: '',
        ratioList: [],
        seriesData: [],
      },
      // 单车出车率分布
      workRateInfoData: {
        title: '单车出车率分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: ['本周出车率分布', '本月出车率分布'],
        data: [],
        tooltip: `针对当周/当月数据，分析出车率分布及占比情况：<br/>
          极低：（0%，20%）<br/>
          较低：【20%，40%）<br/>
          一般：【40%，60%）<br/>
          较高：【60%，80%）<br/>
          极高：【80%，100%】`,
      },
    }
  },
  created() {
    this.getPersonWorkImpactFactors()
  },
  methods: {
    toCustomerOperateList(params = {}) {
      const spId = this.spId || undefined

      this.$router.push({
        path: '/driver/linkage/customerOperate/list',
        query: {
          spId,
          ...params,
        },
      })
    },
    async getPersonWorkImpactFactors() {
      const res = await getPersonWorkImpactFactors({
        spId: this.spId,
      })

      const { code, data } = res

      if (code === 1) {
        // 出车状态
        this.workStatusData.dataUpdateTime = data?.updateTime || ''
        this.workStatusData.total = data?.workStatus?.yesterdayWorkInfo?.value || 0
        this.workStatusData.ratioList = [
          {
            name: '日环比',
            value: data?.workStatus?.yesterdayWorkInfo?.dayRadio,
          },
          {
            name: '周同比',
            value: data?.workStatus?.yesterdayWorkInfo?.weekYoY,
          },
        ]
        this.workStatusData.seriesData = [
          {
            name: '昨日新增出车',
            value: data?.workStatus?.yesterdayAddWorkCarInfo?.value || 0,
            ratio: data?.workStatus?.yesterdayAddWorkCarInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.workStatus?.yesterdayAddWorkCarInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.workStatus?.yesterdayAddWorkCarInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              yesterdayWorkStatus: 1,
            }),
          },
          {
            name: '昨日留存车辆出车',
            value: data?.workStatus?.yesterdayRetainedWorkCarInfo?.value || 0,
            ratio: data?.workStatus?.yesterdayRetainedWorkCarInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.workStatus?.yesterdayRetainedWorkCarInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.workStatus?.yesterdayRetainedWorkCarInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              yesterdayWorkStatus: 2,
            }),
          },
          {
            name: '昨日回流车辆出车',
            value: data?.workStatus?.yesterdayRefluxWorkCarInfo?.value || 0,
            ratio: data?.workStatus?.yesterdayRefluxWorkCarInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.workStatus?.yesterdayRefluxWorkCarInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.workStatus?.yesterdayRefluxWorkCarInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              yesterdayWorkStatus: 3,
            }),
          },
        ]

        // 不可出车原因
        this.noWorkReasonData.dataUpdateTime = data?.updateTime || ''
        this.noWorkReasonData.total = data?.noWorkReason?.yesterdayNoWorkInfo?.value || 0
        this.noWorkReasonData.ratioList = [
          {
            name: '日环比',
            value: data?.noWorkReason?.yesterdayNoWorkInfo?.dayRadio,
          },
          {
            name: '周同比',
            value: data?.noWorkReason?.yesterdayNoWorkInfo?.weekYoY,
          },
        ]
        this.noWorkReasonData.seriesData = [
          {
            name: '网约封号',
            value: data?.noWorkReason?.closeAccountInfo?.value || 0,
            ratio: data?.noWorkReason?.closeAccountInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.noWorkReason?.closeAccountInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.noWorkReason?.closeAccountInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              noWorkReason: 1,
            }),
          },
          {
            name: '车辆维修',
            value: data?.noWorkReason?.maintenanceInfo?.value || 0,
            ratio: data?.noWorkReason?.maintenanceInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.noWorkReason?.maintenanceInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.noWorkReason?.maintenanceInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              noWorkReason: 2,
            }),
          },
          {
            name: '车辆保养',
            value: data?.noWorkReason?.conserveInfo?.value || 0,
            ratio: data?.noWorkReason?.conserveInfo?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.noWorkReason?.conserveInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.noWorkReason?.conserveInfo?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              noWorkReason: 3,
            }),
          },
          {
            name: '其他原因',
            value: data?.noWorkReason?.otherWilling?.value || 0,
            ratio: data?.noWorkReason?.otherWilling?.proportion || 0,
            ratioList: [
              {
                name: '日环比',
                value: data?.noWorkReason?.otherWilling?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.noWorkReason?.otherWilling?.weekYoY,
              },
            ],
            clickCallback: () => this.toCustomerOperateList({
              noWorkReason: 4,
            }),
          },
        ]

        // 单车出车率分布
        this.workRateInfoData.dataUpdateTime = data?.updateTime || ''
        this.workRateInfoData.data = (data?.workRateInfo?.weekWorkRateInfo || WORK_RATE_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          const monthWorkRateInfoItem = (data?.workRateInfo?.monthWorkRateInfo || [])[index]
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '人数',
                    value: item.value || 0,
                    clickCallback: () => this.toCustomerOperateList({
                      weekWorkRate: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
              {
                ratio: monthWorkRateInfoItem?.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '人数',
                    value: monthWorkRateInfoItem?.value || 0,
                    clickCallback: () => this.toCustomerOperateList({
                      monthWorkRate: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: monthWorkRateInfoItem?.proportion || 0,
                  },
                ],
              },
            ],
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
